export default {
        "logout-success": "Cierre de sesión exitoso",
        "logout-error": "Error al cerrar sesión",
        "confirm": "Confirmar",
        "copySuccess": "Copiado",
        "server": {
            "selectServer": "Seleccionar servidor",
            "serverAmerica": "America",
            "serverEurope": "Europe",
            "serverAsia": "Asia",
            "serverHMT": "HMT",
            "serverSEA": "SEA",
            "noRole": "Este personaje no existe. \nInicia sesión en el juego primero.",
            "noRole2": "Este personaje no existe.",
            "noOtherRole": "Personajes no encontrados, \nno se puede cambiar de servidor."
        },
        "uidlogin": { 
            "enterCode": "Por favor ingrese el código",
            "enterCode2": "Por favor ingrese el código correcto",
            "sendCode": "Enviar código",
            "agree": "Por favor lea y acepte los Términos de Uso y la Política de Privacidad",
            "sended": "Enviado",
            "tipUid": "Por favor ingrese la UID",
            "tipUid2": "Por favor ingrese la UID correcta",
            "login": "Iniciar sesión",
            "loginFail": "Inicio de sesión fallido, por favor verifique la UID y el código",
            "loginSuccess": "Inicio de sesión exitoso",
            "sendFail": "No se encontró ningún rol",
            "sendFail2": "Envío fallido",
            "sendFast": "Envío demasiado rápido",
            "sendFast2": "Envío demasiado rápido, por favor inténtelo de nuevo en {time}",
            "codeInvaild": "Código expirado"
        },
        "share-tips": "Mantén pulsado para guardar y compartir"
};
